module.exports = __webpack_public_path__ + "static/media/hang.bf0f5169.svg";